import { createAsyncThunk } from '@reduxjs/toolkit'

import { GetSessionCostEstimateParams } from '@lyrahealth-inc/shared-app-logic/src/features/sessions/types'
import { CostInfo } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'

import { axiosInstance } from '../../common/http/axiosInstance'

export const GET_SESSION_COST_ESTIMATE = 'GET_SESSION_COST_ESTIMATE'

export const getSessionCostEstimate = createAsyncThunk<CostInfo, GetSessionCostEstimateParams>(
  GET_SESSION_COST_ESTIMATE,
  async ({ providerId, userId, sessionType, childLyraId }, { rejectWithValue }) => {
    try {
      const params: Record<string, string> = {
        sessionType,
      }
      if (childLyraId) {
        params.childLyraId = childLyraId
      }

      const response = await axiosInstance.get(`/v1/provider/${providerId}/patient/${userId}/costs`, {
        params,
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)
